class NavSlideOut extends HTMLElement {
  constructor() {
    super();

    var dropdown = this.querySelector('.navigation__grandchild');

    hoverIntent(this, mouseOver);
    hoverIntent(dropdown, '', mouseLeave);

    function mouseOver(){
      hideSlideout();

      if (dropdown) {
        dropdown.classList.add('open');
      }
    }
    
    function mouseLeave(){
      dropdown.classList.remove('open');
    }

    function hideSlideout(){
      var dropdowns = document.querySelectorAll('.navigation__grandchild');

      for (let index = 0; index < dropdowns.length; index++) {
        const element = dropdowns[index];
        element.classList.remove('open');
      }
    }
  }
}

customElements.define("nav-slide-out", NavSlideOut);